export default "__VITE_ASSET__CfMKVE04__"